<article class="word-hanja-layout1"
         #popupContainer
         [style.top]="popupTop + 'px'"
         (click)="onVoid($event)">

  <!-- 에러 발생 시 -->
  <div class="tooltip-wrap"
       *ngIf="hanja && errorTxt">
    <div class="tooltip-head-box hun">
      <div class="hanja">{{ hanja }}</div>
      <a class="tooltip-close-btn"
         (click)="onClose($event)"></a>
    </div>
    <div class="tooltip-item">
      <div class="err">{{ errorTxt }}</div>
    </div>
  </div>

  <!-- 정상 상태 -->
  <div class="tooltip-wrap"
       *ngIf="hanja && !errorTxt">
    <div class="tooltip-head-box hun">
      <div class="hanja">{{ hanja }}</div>
      <a class="tooltip-close-btn"
         (click)="onClose($event)"></a>
    </div>

    <div *ngFor="let saseung3 of listSaseung3"
         class="tooltip-item">
      <div class="tooltip-hun-box">
        <div class="hanja">
          <ng-container *ngFor="let char of getHanjaChars(saseung3.hanja); let i = index">
            <br *ngIf="i > 0 && i % 2 === 0">
            <span class="hanja-txt" [class.first]="i === 0">{{ char }}</span>
          </ng-container>
        </div>
        <div class="saseung-box">
          <div class="hun-box">
            <span class="saseung-txt"
                  *ngFor="let tone of GetFourTonesArray(saseung3.four_tones)">{{ tone }}</span>
            <span class="first-hun">{{ getFirstHun(saseung3) }}</span>
            <b class="hangul">{{ saseung3.hangul }}</b>
          </div>
          <ng-container *ngIf="getRestHun(saseung3) as restHun">
            <div class="rest-hun">{{ restHun }}</div>
          </ng-container>
        </div>
      </div>
    </div>

    <div class="tooltip-item"
         *ngIf="!IsLoading && (listSaseung3?.length ?? 0) === 0">
      <div class="err">문자 정보가 없습니다.</div>
    </div>

    <div class="tooltip-item"
         *ngIf="(listSaseung3?.length ?? 0) > 0">
      <div class="tooltip-link-box">
        <a class="tooltip-link-btn"
           (click)="onCloseMore($event)">
          <span class="txt more"
                *ngIf="getMoreTxt()">{{ getMoreTxt() }}</span>
          <span class="txt">{{ getMoreTxt() ? "전체 보기" : "자세히 보기" }}</span>
          <i class="ic ic-link"></i>
        </a>
      </div>
    </div>

    <div *ngIf="IsLoading"
         class="reload-icon">
      <img src="assets/img/loading_icon.gif"
           alt="로딩 중">
    </div>

  </div>

</article>
